module.exports = new __parcel__URL__("title-menu-loader.2443dbd3.gif").toString();